import { AutorizacionesDtoDiscComponent } from 'src/app/tablas/autorizaciones-dto-disc/autorizaciones-dto-disc.component';
import { AutorizacionesNCComponent } from 'src/app/tablas/autorizaciones-nc/components/autorizaciones-nc.component';
import { CambioClaveComponent } from 'src/app/user-Management/components/cambioclave.component';
import { CampaniasComponent } from 'src/app/tablas/campanias/campanias.component';
import { ConfirmarEmailComponent } from 'src/app/user-Management/components/confirmar-email.component';
import { CuentasComponent } from 'src/app/cuentas/cuentas/components/cuentas.component';
import { DepositosComponent } from 'src/app/tablas/depositos/depositos.component';
import { DistribuidoresComponent } from 'src/app/tablas/distribuidores/distribuidores.component';
import { DivisionesComponent } from 'src/app/tablas/divisiones/divisiones.component';
import { GruposClientesComponent } from 'src/app/tablas/grupos-clientes/components/grupos-clientes.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HomeComponent } from 'src/app/home/components/home.component';
import { InventariosComponent } from 'src/app/productos/inventarios/components/inventarios.component';
import { ItemsParametrosComponent } from 'src/app/adm/parametros/components/items-parametros.component';
import { ListasPreciosComponent } from 'src/app/productos/listas-precios/components/listas-precios.component';
import { LoggedGuard } from '../utils/logged.guard';
import { LoginComponent } from 'src/app/user-Management/components/login.component';
import { MotivosDevolucionNCComponent } from 'src/app/tablas/motivos-devolucion-nc/motivos-devolucion-nc.component';
import { NcBuscadorComponent } from 'src/app/pedidos/notas-credito/components/nc-buscador.component';
import { NcComponent } from 'src/app/pedidos/notas-credito/components/nc.component';
import { NgModule, OnInit } from '@angular/core'
import { NumeradoresComponent } from 'src/app/tablas/numeradores/numeradores.component';
import { PageNotFoundComponent } from 'src/app/page-not-found/components/page-not-found.component';
import { ParametrosComponent } from 'src/app/adm/parametros/components/parametros.component';
import { PEPBuscadorComponent } from 'src/app/pedidos/pedidos-especiales-planta/components/pep-buscador.component';
import { PEPComponent } from 'src/app/pedidos/pedidos-especiales-planta/components/pep.component';
import { ProcesosComponent } from 'src/app/tablas/procesos/components/procesos.component';
import { ProductosComponent } from 'src/app/productos/productos/components/productos.component';
import { PVBuscadorComponent } from 'src/app/pedidos/pedidos-ventas/components/pv-buscador.component';
import { PVComponent } from 'src/app/pedidos/pedidos-ventas/components/pv.component';
import { RegionesComponent } from 'src/app/tablas/regiones/regiones.component';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { TerminosPagoComponent } from 'src/app/tablas/terminos-pago/components/terminos-pago.component';
import { TiposCambioComponent } from 'src/app/tablas/tipos-cambio/tipos-cambio.component';
import { TiposListasPreciosComponent } from 'src/app/tablas/tipos-listas-precios/components/tipos-listas-precios.component';
import { TiposLPPorGrupoClienteComponent } from 'src/app/tablas/tipos-lp-grupo-cliente/tipos-lp-por-grupo-cliente.component';
import { TiposLPPorTerminoPagoComponent } from 'src/app/tablas/tipos-lp-termino-pago/tipos-lp-por-termino-pago.component';
import { UbicacionesAlmacenamientosComponent } from 'src/app/tablas/ubicaciones-almacenamientos/ubicaciones-almacenamientos.component';
import { UsuariosComponent } from 'src/app/adm/usuarios/components/usuarios.component';
import { VerificarCuentaComponent } from 'src/app/user-Management/components/verificar-cuenta.component';
import { ZonasVendedoresComponent } from 'src/app/tablas/zonas-vendedores/zonas-vendedores.component';
import { CotizacionComponent } from 'src/app/pedidos/cotizaciones/components/cotizacion.component';
import { CotizacionesBuscadorComponent } from 'src/app/pedidos/cotizaciones/components/cotizaciones-buscador.component';
import { CuotasPlantasComponent } from 'src/app/productos/cuotas-plantas/cuotas-plantas.component';
import { CuotasDistribuidoresComponent } from 'src/app/productos/cuotas-distribuidores/cuotas-distribuidores.component';
import { PEPABuscadorComponent } from 'src/app/pedidos/pedidos-especiales-planta-anticipada/component/pepa-buscador.component';
import { PEPAComponent } from 'src/app/pedidos/pedidos-especiales-planta-anticipada/component/pepa.component';
import { PVABuscadorComponent } from 'src/app/pedidos/pedidos-ventas-anticipada/components/pva-buscador.component';
import { PVAComponent } from 'src/app/pedidos/pedidos-ventas-anticipada/components/pva.component';
import { ConfirmacionCotizacionComponent } from 'src/app/confirmacion-cotizacion/confirmacion-cotizacion.component';
import { PAComponent } from 'src/app/pedidos/pedidos-abastecimiento/components/pa.component';
import { PABuscadorComponent } from 'src/app/pedidos/pedidos-abastecimiento/components/pa-buscador.component';
import { ReportesPedidosBuscadorComponent } from 'src/app/reportes/reportes-pedidos/components/reportes-pedidos-buscador.component';
import { ReportesPedidosDetalladosBuscadorComponent } from 'src/app/reportes/reportes-pedidos-detallados/components/reportes-pedidos-detallados-buscador.component';
import { TPBuscadorComponent } from 'src/app/pedidos/transferencias-planta/components/tp-buscador.component';
import { TPComponent } from 'src/app/pedidos/transferencias-planta/components/tp.component';
import { TDComponent } from 'src/app/pedidos/tranferencias-distribuidores/components/td.component';
import { TDBuscadorComponent } from 'src/app/pedidos/tranferencias-distribuidores/components/td-buscador.component';
import { ShipToDistribuidoresComponent } from 'src/app/tablas/shipto-distribuidores/shipto-distribuidores.component';

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
  useHash: true,
  onSameUrlNavigation: 'reload'
  // scrollOffset: [0, 64],
};
const routes: Routes = [

  {
    path: 'confirmar-email/:id/:code', component: ConfirmarEmailComponent,
    data: { label: 'Confirmando...' }
  },
  {
    path: 'home', component: HomeComponent, canActivate: [LoggedGuard], data: {
      label:
        'Home'
    }, pathMatch: 'full'
  },

  {
    path: 'login', component: LoginComponent, data: {
      label:
        'Login'
    }, pathMatch: 'full'
  },
  {
    path: 'verificar-cuenta', component: VerificarCuentaComponent, data: {
      label:
        'Verificar Cuenta'
    }, pathMatch: 'full'
  },
  {
    path: 'cambio-clave', component: CambioClaveComponent,
    data: { label: 'Cambiar Clave' }, pathMatch: 'full'
  },
  {
    path: 'usuarios', component: UsuariosComponent, canActivate: [LoggedGuard],
    data: { label: 'Usuarios' }, pathMatch: 'full'
  },
  {
    path: 'terminos-pago', component: TerminosPagoComponent, canActivate: [LoggedGuard],
    data: { label: 'Terminos Pago' }, pathMatch: 'full'
  },
  {
    path: 'parametros', component: ParametrosComponent, canActivate: [LoggedGuard],
    data: { label: 'Parametros' }, pathMatch: 'full'
  },
  {
    path: 'items-parametros', component: ItemsParametrosComponent, canActivate: [LoggedGuard],
    data: { label: 'ItemsParametros' }, pathMatch: 'full'
  },
  {
    path: 'procesos', component: ProcesosComponent, canActivate: [LoggedGuard],
    data: { label: 'Procesos' }, pathMatch: 'full'
  },
  {
    path: 'tipos-cambio', component: TiposCambioComponent, canActivate: [LoggedGuard],
    data: { label: 'Tipos de Cambio' }, pathMatch: 'full'
  },
  {
    path: 'productos', component: ProductosComponent, canActivate: [LoggedGuard],
    data: { label: 'Productos' }, pathMatch: 'full'
  },
  {
    path: 'tipos-listas-precios', component: TiposListasPreciosComponent, canActivate: [LoggedGuard],
    data: { label: 'Tipos Listas Precios' }, pathMatch: 'full'
  },
  {
    path: 'tipos-LP-por-terminos-pago', component: TiposLPPorTerminoPagoComponent, canActivate: [LoggedGuard],
    data: { label: 'Tipos Listas Precios Por Términos de Pago' }, pathMatch: 'full'
  },
  {
    path: 'grupos-clientes', component: GruposClientesComponent, canActivate: [LoggedGuard],
    data: { label: 'Grupos de Clientes' }, pathMatch: 'full'
  },
  {
    path: 'tipos-LP-por-grupo-cliente', component: TiposLPPorGrupoClienteComponent, canActivate: [LoggedGuard],
    data: { label: 'Tipos Listas Precios Por Grupos Clientes' }, pathMatch: 'full'
  },
  {
    path: 'listas-precios', component: ListasPreciosComponent, canActivate: [LoggedGuard],
    data: { label: 'Listas Precios' }, pathMatch: 'full'
  },
  {
    path: 'regiones', component: RegionesComponent, canActivate: [LoggedGuard],
    data: { label: 'Regiones' }, pathMatch: 'full'
  },
  {
    path: 'inventario', component: InventariosComponent, canActivate: [LoggedGuard],
    data: { label: 'Inventario' }, pathMatch: 'full'
  },
  {
    path: 'depositos', component: DepositosComponent, canActivate: [LoggedGuard],
    data: { label: 'Depositos' }, pathMatch: 'full'
  },
  {
    path: 'ubicaciones-almacenamientos', component: UbicacionesAlmacenamientosComponent, canActivate: [LoggedGuard],
    data: { label: 'UbicacionesAlmacenamientos' }, pathMatch: 'full'
  },
  {
    path: 'zonas-vendedores', component: ZonasVendedoresComponent, canActivate: [LoggedGuard],
    data: { label: 'ZonasVendedores' }, pathMatch: 'full'
  },
  {
    path: 'autorizaciones-dto-disc', component: AutorizacionesDtoDiscComponent, canActivate: [LoggedGuard],
    data: { label: 'Autorizaciones dto. discrecional' }, pathMatch: 'full'
  },
  {
    path: 'autorizaciones-nc', component: AutorizacionesNCComponent, canActivate: [LoggedGuard],
    data: { label: 'Autorizaciones notas crédito' }, pathMatch: 'full'
  },
  {
    path: 'distribuidores', component: DistribuidoresComponent, canActivate: [LoggedGuard],
    data: { label: 'Distribuidores' }, pathMatch: 'full'
  },
  {
    path: 'divisiones', component: DivisionesComponent, canActivate: [LoggedGuard],
    data: { label: 'Divisiones' }, pathMatch: 'full'
  },
  {
    path: 'cuentas', component: CuentasComponent, canActivate: [LoggedGuard],
    data: { label: 'Cuentas' }, pathMatch: 'full'
  },
  {
    path: 'campanias', component: CampaniasComponent, canActivate: [LoggedGuard],
    data: { label: 'Campanias' }, pathMatch: 'full'
  },
  {
    path: 'numeradores', component: NumeradoresComponent, canActivate: [LoggedGuard],
    data: { label: 'Numeradores' }, pathMatch: 'full'
  },
  {
    path: 'pedidos-venta', component: PVBuscadorComponent, canActivate: [LoggedGuard],
    data: { label: 'Pedidos Venta' }, pathMatch: 'full'
  },
  {
    path: 'pedidos-venta-anticipada', component: PVABuscadorComponent, canActivate: [LoggedGuard],
    data: { label: 'Pedidos Venta Anticipada' }, pathMatch: 'full'
  },
  {
    path: 'pedidos-especiales-planta', component: PEPBuscadorComponent, canActivate: [LoggedGuard],
    data: { label: 'Pedidos Especiales Planta' }, pathMatch: 'full'
  },
  {
    path: 'pedidos-especiales-planta-anticipada', component: PEPABuscadorComponent, canActivate: [LoggedGuard],
    data: { label: 'Pedidos Especiales Planta Anticipada' }, pathMatch: 'full'
  },
  {
    path: 'notas-credito', component: NcBuscadorComponent, canActivate: [LoggedGuard],
    data: { label: 'Notas Crédito' }, pathMatch: 'full'
  },
  {
    path: 'cotizaciones', component: CotizacionesBuscadorComponent, canActivate: [LoggedGuard],
    data: { label: 'Cotizaciones' }, pathMatch: 'full'
  },
  {
    path: 'pedidos-abastecimiento', component: PABuscadorComponent, canActivate: [LoggedGuard],
    data: { label: 'Pedidos Abastecimiento' }, pathMatch: 'full'
  },
  {
    path: 'transferencias-planta', component: TPBuscadorComponent, canActivate: [LoggedGuard],
    data: { label: 'Transferencias Planta' }, pathMatch: 'full'
  },
  {
    path: 'transferencias-distribuidores', component: TDBuscadorComponent, canActivate: [LoggedGuard],
    data: { label: 'Transferencias entre Distribuidores' }, pathMatch: 'full'
  },
  {
    path: 'reportes-pedidos', component: ReportesPedidosBuscadorComponent, canActivate: [LoggedGuard],
    data: { label: 'Pedidos' }, pathMatch: 'full'
  },
  {
    path: 'reportes-pedidos-detallados', component: ReportesPedidosDetalladosBuscadorComponent, canActivate: [LoggedGuard],
    data: { label: 'Pedidos Detallados' }, pathMatch: 'full'
  },
  {
    path: 'pv', component: PVComponent, canActivate: [LoggedGuard],
    data: { label: 'Pedido Venta' }, pathMatch: 'full'
  },
  {
    path: 'pva', component: PVAComponent, canActivate: [LoggedGuard],
    data: { label: 'Pedido Venta Anticipada' }, pathMatch: 'full'
  },
  {
    path: 'pep', component: PEPComponent, canActivate: [LoggedGuard],
    data: { label: 'Pedido Especial Planta' }, pathMatch: 'full'
  },
  {
    path: 'pepa', component: PEPAComponent, canActivate: [LoggedGuard],
    data: { label: 'Pedido Especial Planta Anticipada' }, pathMatch: 'full'
  },
  {
    path: 'nc', component: NcComponent, canActivate: [LoggedGuard],
    data: { label: 'Nota Crédito' }, pathMatch: 'full'
  },
  {
    path: 'cotizacion', component: CotizacionComponent, canActivate: [LoggedGuard],
    data: { label: 'Cotización' }, pathMatch: 'full'
  },
  {
    path: 'confirmacion-cotizacion', component: ConfirmacionCotizacionComponent,
    data: { label: 'Confimarción Cotización'}, pathMatch: 'full'
  },
  {
    path: 'motivos-devolucion-nc', component: MotivosDevolucionNCComponent, canActivate: [LoggedGuard],
    data: { label: 'Motivo Devolución NC' }, pathMatch: 'full'
  },
  {
    path: 'cuotas-plantas', component: CuotasPlantasComponent, canActivate: [LoggedGuard],
    data: { label: 'Cuota Planta' }, pathMatch: 'full'
  },
  {
    path: 'cuotas-distribuidores', component: CuotasDistribuidoresComponent, canActivate: [LoggedGuard],
    data: { label: 'Cuota Distribuidor' }, pathMatch: 'full'
  },
  {
    path: 'pa', component: PAComponent, canActivate: [LoggedGuard],
    data: { label: 'Pedido de Abastecimiento' }, pathMatch: 'full'
  },
  {
    path: 'tp', component: TPComponent, canActivate: [LoggedGuard],
    data: { label: 'Transferencia a Planta' }, pathMatch: 'full'
  },
  {
    path: 'td', component: TDComponent, canActivate: [LoggedGuard],
    data: { label: 'Transferencia entre Distribuidores' }, pathMatch: 'full'
  },
    {
    path: 'shipto-distribuidores', component: ShipToDistribuidoresComponent, canActivate: [LoggedGuard],
    data: { label: 'Shipto Distribuidores' }, pathMatch: 'full'
  },

  {
    path: '',
    component: HomeComponent, canActivate: [LoggedGuard]
  },
  {
    path: '**'
    , component: PageNotFoundComponent, data: { label: 'URL Incorrecta' }, pathMatch: 'full'
  },

];


@NgModule({

  // imports: [RouterModule.forRoot(routes, routerOptions)],
  imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload', scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }]
})


export class RoutingModule {


}